import PropTypes from "prop-types";
import React from "react";

import { Section, Text } from "@swa-ui/core";
import { CheckboxFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./AnimalAssistanceFormField.module.scss";
import { ANIMAL_ASSISTANCE_SCHEMA_FIELD_NAME } from "./AnimalAssistanceFormField.schema";

export const AnimalAssistanceFormField = (props) => {
  const { serviceAnimalFieldName = ANIMAL_ASSISTANCE_SCHEMA_FIELD_NAME } = props;

  return (
    <Section {...getSectionProps()}>
      <CheckboxFormField {...getCheckboxFormFieldProps()} />
      <Text {...getDisclaimerTextProps()}>{i18n("AnimalAssistanceFormField__DISCLAIMER")}</Text>
    </Section>
  );

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("AnimalAssistanceFormField__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "medium",
      },
    };
  }

  function getCheckboxFormFieldProps() {
    return {
      className: styles.checkboxFormField,
      componentProps: {
        label: (
          <PlacementInfoLabel
            label="AnimalAssistanceFormField__SERVICE_ANIMAL"
            placementId="disabilityOptionAssistanceAnimal"
          />
        ),
      },
      hideBottomSection: true,
      name: serviceAnimalFieldName,
    };
  }

  function getDisclaimerTextProps() {
    return {
      className: styles.disclaimer,
      color: "var(--service-animal-disclaimer-text)",
      size: "large",
    };
  }
};

export const animalAssistanceFormFieldsPropTypes = {
  /** Field name for service animal assistance checkbox. */
  serviceAnimalFieldName: PropTypes.string,
};

AnimalAssistanceFormField.propTypes = animalAssistanceFormFieldsPropTypes;
